import { enumTrpc } from '@/proto/generated/tpro_rmonitor_web_server_memory_detail';
import HprofFileStatus = enumTrpc.rmonitor.web_server.HprofFileStatus;
// 单个大对象
export const SINGLE = 'single';

// 密集大对象
export const INTENSIVE = 'intensive';

// 单次上报分析
export const ANALYZE = 'analyze';

// 泄漏对象
export const LEAK = 'LEAK';

export const REPORT_ISSUE = 'report_issue';


export enum StandardMemoryDetailFieldKey {
  DeatilObjectSize= 'standard_detail_object_size',
};

export enum MemoryDetailFieldKey {
  DeatilObjectSize= 'detail_object_size',
};

export type HprofFileStatusType = HprofFileStatus;

export const HPROF_FILE_STATUS_OPTIONS = [
  { value: HprofFileStatus.ALL, label: '所有' },
  { value: HprofFileStatus.PARSED, label: '已分析' },
  { value: HprofFileStatus.UNPARSED, label: '未分析' },
];
